import { SectionHead, FadeUp } from "./Reveal";

const QUOTES = [
  {
    text: "She became a vital part of our team. I've never seen 21 so well taken care of on tour. Ariane truly handled her business.",
    name: "Mega Meezy",
    role: "Manager of 21 Savage",
    tid: "testimonial-mega-meezy",
  },
  {
    text: "Over the past two decades we have had her come and set up backstage to treat performers and touring crew — without exception people have walked out of her room glowing, with a calm countenance, perhaps even standing a little taller.",
    name: "Tom Fijal",
    role: "Live Nation Touring Rep",
    tid: "testimonial-tom-fijal",
  },
  {
    text: "She would just adjust to what I needed — juices, breathwork, bodywork pre and post shows.",
    name: "Post Malone",
    role: "Recording Artist",
    tid: "testimonial-post-malone",
  },
  {
    text: "She cared for our cast with incredible passion, knowledge and what I can only describe as a healing touch. I would trust Ariane wholeheartedly, both professionally and personally.",
    name: "Amy Wright",
    role: "Executive Producer · Casting Director · Choreographer",
    tid: "testimonial-amy-wright",
  },
  {
    text: "Ariane's work goes far beyond RMT. What may seem like a luxury is truly an essential part of maintaining overall well-being.",
    name: "Stephane Lecuyer",
    role: "Tour Producer",
    tid: "testimonial-stephane-lecuyer",
  },
  {
    text: "Ariane is amazing. She's like our tour mother. She takes care of us.",
    name: "Lamar Johnson",
    role: "Actor — The Last of Us",
    tid: "testimonial-lamar-johnson",
  },
];

export const Testimonials = () => (
  <section id="testimonials" className="relative py-24 lg:py-32" data-testid="testimonials-section">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <SectionHead
        eyebrow="Word of mouth"
        title={<>Trusted by the people <em className="italic text-gold">the world watches</em>.</>}
        sub="Documented testimonials from tours, sets and productions."
      />
      <div className="mt-14 grid gap-5 md:grid-cols-2 lg:grid-cols-3">
        {QUOTES.map((q, i) => (
          <FadeUp key={q.tid} delay={(i % 3) * 0.08} className="h-full">
            <figure className="h-full flex flex-col justify-between rounded-2xl border border-white/10 bg-ink2 p-7 transition-all duration-500 hover:border-gold/35 hover:shadow-[0_18px_50px_rgba(212,175,55,0.07)]" data-testid={q.tid}>
              <blockquote className="font-serif text-xl sm:text-[1.35rem] font-light leading-snug text-ivory/90">
                <span className="text-gold text-3xl leading-none" aria-hidden="true">“</span>
                {q.text}”
              </blockquote>
              <figcaption className="mt-6 border-t border-white/10 pt-4">
                <p className="text-sm text-ivory font-medium">{q.name}</p>
                <p className="mt-1 font-mono text-[9px] uppercase tracking-[0.18em] text-mute">{q.role}</p>
              </figcaption>
            </figure>
          </FadeUp>
        ))}
      </div>
    </div>
  </section>
);
